import type { Cover } from "@pdfking/book3d"

import type { ResolvedGrow } from "#internal"

/** The grow's pieces as the dynamic content draws them: each leaf's kind and
 * box, its name, the pages it shows and how it is laid. */
export const GrowPieces = (grow: ResolvedGrow): Cover["pieces"] =>
  grow.leaves.map(({ kind, box, meta, flip }) => ({
    enum: kind,
    box,
    label: meta.label,
    page_front: meta.page_front,
    page_rear: meta.page_rear,
    rotation: meta.rotation,
    flip,
  }))
